export const useLoaderStore = defineStore({
  id: 'loaderStore',
  state: () => ({
    isOpen: true,
  }),
})
